module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "orders-list"
    }
  }, [_c('aside', [_c('table', {
    staticClass: "table table-hover table-outlined table-oreders"
  }, [_c('thead', [_c('th', [_vm._v(_vm._s(_vm.$t("dashboardModule.thOrderID")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("dashboardModule.thBuyer")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("dashboardModule.thLastActivity")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("dashboardModule.thStatus")))])]), _vm._v(" "), _c('tbody', _vm._l((_vm.orderList), function(OrdersList, key) {
    return _c('tr', {
      key: key
    }, [_c('td', [(OrdersList.status.reference_status !== 'order_deleted') ? _c('router-link', {
      attrs: {
        "to": {
          name: 'MyOrder',
          params: {
            id: OrdersList.id
          }
        }
      }
    }, [_vm._v("\n                            " + _vm._s(OrdersList.reference) + "\n                        ")]) : _vm._e(), _vm._v(" "), (OrdersList.status.reference_status === 'order_deleted') ? _c('span', [_vm._v(" " + _vm._s(OrdersList.reference) + " ")]) : _vm._e()], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(OrdersList.createdBy.firstname) + " " + _vm._s(OrdersList.createdBy.lastname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(OrdersList.modifiedDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getTranslate(OrdersList.status.name)))])])
  }))])]), _vm._v(" "), _vm._t("default", null, {
    slot: "footer"
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fbbfcebc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/orders/order-common/order-list.vue
// module id = 3407
// module chunks = 0